import { render } from "./BoqItemTableBreakdown.vue?vue&type=template&id=3179f978&scoped=true"
import script from "./BoqItemTableBreakdown.vue?vue&type=script&lang=js"
export * from "./BoqItemTableBreakdown.vue?vue&type=script&lang=js"

import "./BoqItemTableBreakdown.vue?vue&type=style&index=0&id=3179f978&scoped=true&lang=css"
import "./BoqItemTableBreakdown.vue?vue&type=style&index=1&id=3179f978&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3179f978"]])

export default __exports__